import React, { FunctionComponent } from 'react';
import { Box } from '@rebass/emotion';

interface FooterProps {
  mq(params: any): any;
  strings: {
    description: string;
  };
}

const Footer: FunctionComponent<FooterProps> = ({ mq, strings: { description } }) => {
  return (
    <Box
      id="footer"
      css={mq({
        display: 'block',
        clear: 'both',
        background: '#333f48',
        height: 'auto',
        position: 'relative',
        width: '100vw',
        padding: '26px 0',
      })}
    >
      <Box maxWidth={['100%', '90%', '80%', '1170px']} width="100%" pr="15px" pl="15px" mr="auto" ml="auto">
        <Box pr="15px" pl="15px">
          <Box
            css={mq({
              boxSizing: 'border-box',
              paddingLeft: 0,
              paddingRight: 0,
              paddingTop: '10px',
              paddingBottom: '5px',
              color: '#b4b4b4',
              lineHeight: 1.6,
            })}
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export { Footer };
